import { newPortfolioComponent } from './newPortfolio.component';
import { stateResolver } from '../../app.state';

export const newPortfolioStateName = 'app.newPortfolio';

export const newPortfolioState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    url: '/newPortfolio',
    name: newPortfolioStateName,
    component: newPortfolioComponent.name,
    resolve: { stateResolver: stateResolver(newPortfolioStateName) },
  });
};



// WEBPACK FOOTER //
// ./src/app/components/newPortfolio/newPortfolio.state.js